import React from "react";
import PageWithConfigurator from "../../global/pageWithConfigurator/pageWithConfigurator";

import IntroBreakdownModule from "./introBreakdown";
import NoVisitAfterFirstVisitModule from "./noVisitAfterFirstVisit";
import IntroductoryOfferModule from "./IntroductoryOffer";
import RetainedAndExpiredIntrosModule from "./RetainedAndExpiredIntros";
import HeatmapModule from "./heatmap";
import FunnelRetention from "./funnelRetention";

const pageConfig = {
  pageName: "Retention",
  configuratorWidth: 470,
  moduleList: [
    IntroBreakdownModule,
    NoVisitAfterFirstVisitModule,
    IntroductoryOfferModule,
    RetainedAndExpiredIntrosModule,
    HeatmapModule,
    FunnelRetention
  ]
};

const RetentionPage = ({ notifications }) => (
  <PageWithConfigurator pageConfig={pageConfig} notifications={notifications} />
);

export default RetentionPage;
